module.exports = __webpack_public_path__ + "img/24.d6df81a7.png";